module.exports = __webpack_public_path__ + "img/木棉皮.e067e9a7.jpg";